/**
 * @module sagas/Api.js
 */
import { all, take } from 'redux-saga/effects';

import ApiError from '../lib/error/ApiError';
import { tryCall } from '../sagas/Helpers';
import * as ApiWorkers from '../sagas/workers/Api';

import { taskManagerSpawnFactory } from './Helpers/SpawnedTaskManager';

const spawn = taskManagerSpawnFactory();
const LOOP = true;

// WATCHERS
/**
 * Watch for any actions that have an ApiError attached to them
 */
export function* watchApiFail() {
  while (LOOP) {
    const action = yield take(a => {
      return a.error && a.error instanceof ApiError;
    });

    yield tryCall(ApiWorkers.onApiFail, action);
  }
}

/**
 * Root Api Saga
 */
export default function* apiSaga() {
  yield all([spawn(watchApiFail)]);
}
